// src/Components/Header/header.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom"; 
import "../../styles/header.css";
import logo from "../../assets/mathilogo.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className="header">
      {/* 1. Logo Section */}
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img 
                src={logo}
            alt="Madhi Academy Logo" 
          />
        </Link>
      </div>

      {/* 2. Hamburger Icon (Visible only on Mobile) */}
      <div className="menu-icon" onClick={toggleMenu}>
        {/* SVG Hamburger Icon - Works without FontAwesome */}
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </div>

      {/* 3. Navigation Menu */}
      <nav className={`navbar ${isOpen ? "active" : ""}`}>
        
        {/* Mobile Header inside Menu (Logo + Close Button) */}
        <div className="mobile-menu-header">
           <img 
                src={logo}
              alt="Madhi Logo" 
              className="mobile-logo"
           />
           {/* Close 'X' Button SVG */}
           <div className="close-btn" onClick={closeMenu}>
             <svg 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
             >
               <line x1="18" y1="6" x2="6" y2="18"></line>
               <line x1="6" y1="6" x2="18" y2="18"></line>
             </svg>
           </div>
        </div>

        {/* Links */}
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/about" onClick={closeMenu}>About Us</Link>
        <Link to="/enroll" onClick={closeMenu}>Enroll Now</Link>
        <Link to="/faq" onClick={closeMenu}>FAQ</Link>
        <Link to="https://blog.degree.madhiacademy.com/" onClick={closeMenu}>Blog</Link>
        <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
      </nav>

      {/* 4. Overlay */}
      {isOpen && <div className="overlay" onClick={closeMenu}></div>}
    </header>
  );
};

export default Header;